module.exports = __webpack_public_path__ + "static/media/logo.0fd45c82.png";